/* eslint-disable @typescript-eslint/naming-convention */
import apiServices from 'config/apiServiceApiGateway'
import { Get as GetAPILegacy } from 'config/apiServiceConfig'
import { CategoryType } from '../@types/Category'

const { Get } = apiServices

export const getCategoryById = (categoryId: number) =>
  Get<CategoryType, true>({
    url: '/browse/internal/:version/category/:categoryId',
    version: 'v1',
    urlParams: { categoryId },
  })

export type CategoryWIMSType = {
  name: string
  id: number
  mslod: number
  mslor: number
  msltc: number
  children?: CategoryWIMSType[]
}

export type GetCategoryWIMSQueryParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  'pagination.sort'?: string
  'pagination.direction'?: 'asc' | 'desc'
  'filter.active'?: boolean
  'filter.name'?: string
}

export const getNewCategoriesWIMS = (params: GetCategoryWIMSQueryParamsType) =>
  Get<CategoryWIMSType[]>({
    url: '/wims/internal/v1/categories',
    params,
  })
export type GetCategoryListRequestType = {
  params: {
    index?: number
    name?: string
  }
}

export type GetCategoryListResponseType = {
  content: {
    category_id: number
    category_name: string
  }[]
}
export const getCategoryList = ({ params }: GetCategoryListRequestType) =>
  GetAPILegacy<GetCategoryListResponseType>({ url: `/api/category`, params })
